(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSActividadDialogController', SSActividadDialogController);

    SSActividadDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSActividad', 'SSPerfil'];

    function SSActividadDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSActividad, SSPerfil) {
        var vm = this;

        vm.sSActividad = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssperfils = SSPerfil.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSActividad.id !== null) {
                SSActividad.update(vm.sSActividad, onSaveSuccess, onSaveError);
            } else {
                SSActividad.save(vm.sSActividad, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSActividadUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
